import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    clientname: {
      validations: []
    },
    theme: {
      validations: []
    },
    eventdate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    starttime: {
      validations: []
    },
    endtime: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name: (If Applicable)',
            mapping: 'clientname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Nature of Event:',
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventdate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Start Time:',
            options: [
              { label: '6:00AM'  , value: '06:00:00'},
              { label: '6:30AM'  , value: '06:30:00'},
              { label: '7:00AM'  , value: '07:00:00'},
              { label: '7:30AM'  , value: '07:30:00'},
              { label: '8:00AM'  , value: '08:00:00'},
              { label: '8:30AM'  , value: '08:30:00'},
              { label: '9:00AM'  , value: '09:00:00'},
              { label: '9:30AM'  , value: '09:30:00'},
              { label: '10:00AM' , value: '10:00:00'},
              { label: '10:30AM' , value: '10:30:00'},
              { label: '11:00AM' , value: '11:00:00'},
              { label: '11:30AM' , value: '11:30:00'},
              { label: '12:00PM' , value: '12:00:00'},
              { label: '12:30PM' , value: '12:30:00'},
              { label: '1:00PM'  , value: '13:00:00'},
              { label: '1:30PM'  , value: '13:30:00'},
              { label: '2:00PM'  , value: '14:00:00'},
              { label: '2:30PM'  , value: '14:30:00'},
              { label: '3:00PM'  , value: '15:00:00'},
              { label: '3:30PM'  , value: '15:30:00'},
              { label: '4:00PM'  , value: '16:00:00'},
              { label: '4:30PM'  , value: '16:30:00'},
              { label: '5:00PM'  , value: '17:00:00'},
              { label: '5:30PM'  , value: '17:30:00'},
              { label: '6:00PM'  , value: '18:00:00'},
              { label: '6:30PM'  , value: '18:30:00'},
              { label: '7:00PM'  , value: '19:00:00'},
              { label: '7:30PM'  , value: '19:30:00'},
              { label: '8:00PM'  , value: '20:00:00'},
              { label: '8:30PM'  , value: '20:30:00'},
              { label: '9:00PM'  , value: '21:00:00'},
              { label: '9:30PM'  , value: '21:30:00'},
              { label: '10:00PM' , value: '22:00:00'}
            ],
            mapping: 'starttime'
          }
        ]
      },
      {
        fields: [
          {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'Event End Time:',
        options: [
          { label: '6:00 AM'  , value: '06:00:00'},
          { label: '6:30 AM'  , value: '06:30:00'},
          { label: '7:00 AM'  , value: '07:00:00'},
          { label: '7:30 AM'  , value: '07:30:00'},
          { label: '8:00 AM'  , value: '08:00:00'},
          { label: '8:30 AM'  , value: '08:30:00'},
          { label: '9:00 AM'  , value: '09:00:00'},
          { label: '9:30 AM'  , value: '09:30:00'},
          { label: '10:00 AM' , value: '10:00:00'},
          { label: '10:30 AM' , value: '10:30:00'},
          { label: '11:00 AM' , value: '11:00:00'},
          { label: '11:30 AM' , value: '11:30:00'},
          { label: '12:00 PM' , value: '12:00:00'},
          { label: '12:30 PM' , value: '12:30:00'},
          { label: '1:00 PM'  , value: '13:00:00'},
          { label: '1:30 PM'  , value: '13:30:00'},
          { label: '2:00 PM'  , value: '14:00:00'},
          { label: '2:30 PM'  , value: '14:30:00'},
          { label: '3:00 PM'  , value: '15:00:00'},
          { label: '3:30 PM'  , value: '15:30:00'},
          { label: '4:00 PM'  , value: '16:00:00'},
          { label: '4:30 PM'  , value: '16:30:00'},
          { label: '5:00 PM'  , value: '17:00:00'},
          { label: '5:30 PM'  , value: '17:30:00'},
          { label: '6:00 PM'  , value: '18:00:00'},
          { label: '6:30 PM'  , value: '18:30:00'},
          { label: '7:00 PM'  , value: '19:00:00'},
          { label: '7:30 PM'  , value: '19:30:00'},
          { label: '8:00 PM'  , value: '20:00:00'},
          { label: '8:30 PM'  , value: '20:30:00'},
          { label: '9:00 PM'  , value: '21:00:00'},
          { label: '9:30 PM'  , value: '21:30:00'},
          { label: '10:00 PM' , value: '22:00:00'},
          { label: '10:30 PM' , value: '22:30:00'},
          { label: '11:00 PM', value: '23:00:00' },
          { label: '11:30 PM', value: '23:30:00' },
          { label: '12:00 AM', value: '00:00:00' },
          { label: '12:30 AM', value: '00:30:00' },
          { label: '1:00 AM', value: '01:00:00' },
          { label: '1:30 AM', value: '01:30:00' },
          { label: '2:00 AM', value: '02:00:00' },
        ],
        mapping: 'endtime'
      }
    ]
  },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Remo\'s Catering Contact Form',
    formId: '2114',
    clientKey: '062DBE17-6485-481B-B07D-693B67C90872',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'Thank you! Your request has been received. We will reach out to you within 24 business hours.',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
